$(function() {
    // Global Slide Up Animation Function using GSAP
    // Simple scroll-based animation that only runs once when scrolling down
    // Usage: Add data-slide-up attribute to any element in HTML
    // Optional attributes:
    // - data-slide-duration: Animation duration (default: 0.8)
    // - data-slide-delay: Animation delay (default: 0)
    // - data-slide-distance: Slide distance in pixels (default: 50)
    // - data-slide-trigger-start: When animation starts (default: "top 80%")
    // - data-slide-ease: Easing function (default: "power2.out")

    // Track elements that have been animated to prevent re-animation
    const animatedElements = new Set();

    function initSlideUpAnimations() {
        // Check if GSAP is available
        if (typeof gsap === 'undefined') {
            console.warn('GSAP not found. Slide animations will not work.');
            return;
        }

        // Find all elements with data-slide-up attribute
        const slideElements = document.querySelectorAll('[data-slide-up]');
        
        // Set initial state for all elements
        slideElements.forEach((element) => {
            const distance = parseInt(element.dataset.slideDistance) || 50;
            gsap.set(element, {
                y: distance,
                opacity: 0,
                visibility: 'visible'
            });
        });

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll, { passive: true });
        
        // Check on initial load
        handleScroll();
    }

    function handleScroll() {
        const slideElements = document.querySelectorAll('[data-slide-up]');
        const windowHeight = window.innerHeight;
        const scrollY = window.scrollY;
        
        slideElements.forEach((element) => {
            // Skip if already animated
            if (animatedElements.has(element)) {
                return;
            }

            const rect = element.getBoundingClientRect();
            const elementTop = rect.top + scrollY;
            const triggerOffset = windowHeight * 0.8; // 80% of viewport height
            
            // Check if element has scrolled into trigger area
            if (scrollY + triggerOffset >= elementTop) {
                animateElement(element);
            }
        });
    }

    function animateElement(element) {
        // Mark as animated immediately to prevent re-animation
        animatedElements.add(element);

        // Get configuration from data attributes or use defaults
        const duration = parseFloat(element.dataset.slideDuration) || 0.8;
        const delay = parseFloat(element.dataset.slideDelay) || 0;
        const ease = element.dataset.slideEase || "power2.out";

        // Animate the element
        gsap.to(element, {
            y: 0,
            opacity: 1,
            duration: duration,
            delay: delay,
            ease: ease
        });
    }

    // Function to detect if page is in edit mode
    function isEditMode() {
        // Check for editor path
        const isEditorPath = top.location.pathname.includes('/editor.html');
        
        if (isEditorPath) {
            return 'AUTHOR';
        }
        return 'PUBLISH';
    }

    // Initialize on document ready
    $(document).ready(function() {
        // Skip animation initialization if in edit mode
        if (isEditMode() === 'AUTHOR') {
            return;
        }
        
        // Add a small delay to ensure DOM is ready
        setTimeout(() => {
            initSlideUpAnimations();
        }, 100);
    });

    // Reinitialize function for dynamic content
    window.reinitSlideUpAnimations = function() {
        // Skip reinitialization if in edit mode
        if (isEditMode() === 'AUTHOR') {
            return;
        }
        
        // Clear animated elements cache
        animatedElements.clear();
        
        // Reinitialize
        setTimeout(() => {
            initSlideUpAnimations();
        }, 100);
    };

    // Utility function to clear animated elements cache
    window.clearAnimatedElementsCache = function() {
        animatedElements.clear();
    };

    // Utility function to force animation for specific elements
    window.forceAnimateElement = function(element) {
        if (!animatedElements.has(element)) {
            animateElement(element);
        }
    };
}); 